









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class AboutMyColorBase extends Vue {
  @Prop({ default: 'div' })
  tag: string
}
